<template>
  <AModal
    v-model="active"
    class="gallery-video-modal"
    size="xl"
    @modalhidden="$emit('modalToggled')"
  >
    <div class="embed-responsive embed-responsive-16by9">
      <iframe
        id="video"
        class="embed-responsive-item"
        :src="src"
        allowscriptaccess="always"
        allow="autoplay"
      />
    </div>
  </Amodal>
</template>

<script>
export default {
  name: 'video-modal',
  props: {
    src: {
      type: String,
      required: true
    }
  },
  data: () => {
    return {
      active: false
    }
  },
  methods: {
    activate() {
      this.active = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .a-modal.gallery-video-modal::v-deep .modal-inner .modal-header { display: none; }
  .a-modal.gallery-video-modal::v-deep .modal-inner .modal-body { padding: 0; }
  .a-modal.gallery-video-modal::v-deep .modal-inner .modal-header .close-button svg path { fill: #fff; }

  .embed-responsive {
    position: relative;
    height: 0;
    padding-bottom: 56.25%;

    iframe {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
</style>
